export default {
	channel: 'online',
	staffMemberID: 0,
	telSale: 0
};
